module.exports = __webpack_public_path__ + "static/media/g-what-small.c215053c.png";